import api from './newApi/api'

export type CarlaoNotificationType = 'wizard_refused' | 'wizard_approved'

export interface CarlaoNotificationPayload {
    reason?: string
    refused_by?: number
    refused_by_name?: string
    attendance_id?: number | null
    patient_name?: string | null
}

export interface CarlaoNotification {
    id: number
    user_id: number
    session_id: string
    type: CarlaoNotificationType
    payload: CarlaoNotificationPayload | null
    read_at: string | null
    created_at: string
}

export interface CarlaoNotificationListResponse {
    items: CarlaoNotification[]
    total: number
    unread: number
    page: number
    per_page: number
}

export async function fetchCarlaoNotifications(
    page = 1,
    perPage = 20
): Promise<CarlaoNotificationListResponse> {
    const url = `/internal/carlao/notifications?page=${page}&per_page=${perPage}`
    const response = await api.get<{ data: CarlaoNotificationListResponse }>(url)
    return response.data.data
}

export async function markCarlaoNotificationRead(id: number): Promise<void> {
    await api.patch(`/internal/carlao/notifications/${id}`)
}
